import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../ModalTrigger';
import ReferralOptions from '../../ReferralsIndexContainer/ReferralOptions';
import { putRequest } from '../../../requestUtils';
import logoImg from '../../../../assets/images/Logo_Gray.svg';
import './ConfirmSubmitProposal.scss';

class ConfirmSubmitProposal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fullName: props.fullName,
      currentStep: props.fullName ? 1 : 0,
      error: null,
      isSubmitted: false,
      ProposalDetails: {},
    };
    this.handleUpdateName = this.handleUpdateName.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const fullName = event.target.value;
    this.setState({ fullName });
  }

  handleUpdateName() {
    const { updateUserSettingsUrl, csrfToken } = this.props;
    const { fullName } = this.state;
    if (fullName) {
      putRequest(
        updateUserSettingsUrl,
        { user: { full_name: fullName } },
        csrfToken,
      ).then(() => {
        this.setState({ error: null, currentStep: 1, isSubmitted: false });
      });
    }
  }

  handleSubmit() {
    const { formUrl, csrfToken } = this.props;
    return putRequest(
      formUrl,
      {},
      csrfToken,
    ).then(({ data }) => {
      this.setState({
        error: null,
        currentStep: 2,
        isSubmitted: true,
        proposalDetails: data,
      });
    }).catch((err) => {
      this.setState({ error: err.error });
    });
  }

  renderStep() {
    const { csrfToken, submitToOpenMarketplace, referralProps } = this.props;
    const { fullName, currentStep, error } = this.state;

    if (currentStep === 0) {
      return (
        <div className="text-center">
          <img src={logoImg} alt="Clora" className="logo" />
          <h1 className="mb-2 medium-weight">Please add your name before submitting</h1>
          <form id="update-full-name" onSubmit={(event) => event.preventDefault()}>
            <input
              type="text"
              id="full_name"
              className="form-control fs-hide mt-3  mb-3 "
              placeholder="Full Name"
              name="user[full_name]"
              value={fullName}
              onChange={(event) => this.handleChange(event)}
              required
            />
            <button
              id="update-name-button"
              className="btn btn-primary mb-45"
              onClick={() => this.handleUpdateName()}
            >
              Add Name
            </button>
          </form>
        </div>
      );
    } if (currentStep === 1) {
      return (
        <div className="text-center">
          <img src={logoImg} alt="Clora" className="logo" />
          <h1 className="mb-2 medium-weight">You are about to submit your proposal</h1>
          <div className="flex-center">
            {submitToOpenMarketplace
            && (
            <div className="body-text-2">
              Your proposal will be sent directly to the hiring manager.
              If accepted, Clora will coordinate the interview.
              Check your proposal&#39;s status under My Applications.
            </div>
            )}
            {!submitToOpenMarketplace
            && (
            <div className="body-text-2">
              Clora will review your proposal and reach out to you shortly. You can also check
              your proposal&#39;s status under My Applications.
            </div>
            )}
          </div>
          { error
            && <div className="alert alert-danger">{error}</div>}
        </div>
      );
    }

    return (
      <ReferralOptions
        {...referralProps}
        csrfToken={csrfToken}
        location="Proposal Submission"
        heroCopy="Proposal Successfully Submitted!"
        referredUserType="consultant"
      />
    );
  }

  render() {
    const {
      triggerText,
      animation,
      disabled,
      buttonStyles,
      handleProposalAfterSubmit,
    } = this.props;
    const { currentStep, proposalDetails } = this.state;
    return (
      <ModalTrigger
        triggerText={triggerText}
        disabled={disabled}
        cancelButtonText="No, Cancel"
        submitButtonText="Yes, Submit"
        buttonStyles={buttonStyles}
        handleSubmit={this.handleSubmit}
        idKey="confirm-submit-proposal-modal"
        animation={animation}
        showFooter={currentStep === 1}
        onCloseCallback={() => handleProposalAfterSubmit(proposalDetails)}
      >
        <div className="confirm-submit-proposal style-guide">
          {this.renderStep()}
        </div>
      </ModalTrigger>
    );
  }
}

ConfirmSubmitProposal.propTypes = {
  fullName: PropTypes.string,
  updateUserSettingsUrl: PropTypes.string.isRequired,
  triggerText: PropTypes.string,
  formUrl: PropTypes.string.isRequired,
  submitToOpenMarketplace: PropTypes.bool,
  csrfToken: PropTypes.string.isRequired,
  animation: PropTypes.bool,
  disabled: PropTypes.bool,
  referralProps: PropTypes.shape({
    shareOnLinkedinUrl: PropTypes.string.isRequired,
    referralPath: PropTypes.string.isRequired,
    newReferralPath: PropTypes.string.isRequired,
    authCodeUrl: PropTypes.string.isRequired,
  }).isRequired,
  buttonStyles: PropTypes.string,
  handleProposalAfterSubmit: PropTypes.func,
};

ConfirmSubmitProposal.defaultProps = {
  fullName: null,
  submitToOpenMarketplace: false,
  triggerText: 'Submit Proposal',
  animation: true,
  disabled: false,
  buttonStyles: 'primary',
  handleProposalAfterSubmit: () => {},
};

export default ConfirmSubmitProposal;
